import React, { createContext, useContext, useState, useCallback } from "react";

interface OnboardingVideoContextType {
  isOpen: boolean;
  videoURL: string;
  openVideo: (url: string) => void;
  closeVideo: () => void;
}

const OnboardingVideoContext = createContext<OnboardingVideoContextType | undefined>(undefined);

export const useOnboardingVideo = () => {
  const context = useContext(OnboardingVideoContext);
  if (!context) {
    throw new Error("useOnboardingVideo must be used within an OnboardingVideoProvider");
  }
  return context;
};

interface OnboardingVideoProviderProps {
  children: React.ReactNode;
}

export const OnboardingVideoProvider: React.FC<OnboardingVideoProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [videoURL, setVideoURL] = useState("");

  const openVideo = useCallback((url: string) => {
    setVideoURL(url);
    setIsOpen(true);
  }, []);

  const closeVideo = useCallback(() => {
    setIsOpen(false);
    setVideoURL("");
  }, []);

  const value = {
    isOpen,
    videoURL,
    openVideo,
    closeVideo,
  };

  return <OnboardingVideoContext.Provider value={value}>{children}</OnboardingVideoContext.Provider>;
};
